
export default class PageState {
	orderIds: any[] = []
	isAll:boolean = false
	totalMoney:number = 0

	invoiceDetail:any[]=[]
}